import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import {HttpError} from '@wix/http-client'
import {RegistrationErrorKey} from '../../../../commons/enums'
import {getOrder, placeOrder, updateOrder} from '../actions/placed-order'
import {makeReservation} from '../actions/reservation'
import {resetRsvpError, sendRsvp, sendRsvpOld, updateRsvp, updateRsvpOld} from '../actions/rsvp'
import {FormSubmitErrors} from '../types/state'

const getDefaultState = (): FormSubmitErrors => ({
  error: {},
  errorTime: null,
  canRetry: false,
})

export const formSubmitErrors = createReducer(getDefaultState(), builder => {
  builder
    .addMatcher(
      isAnyOf(placeOrder.rejected, updateOrder.rejected, sendRsvpOld.rejected, updateRsvpOld.rejected),
      (state, action) => {
        const error: HttpError = action.payload as HttpError

        state.error = error?.response?.data?.metadata ?? {error_key: RegistrationErrorKey.UNKNOWN_REGISTRATION_ERROR}
        state.canRetry = canRetryError(error)
        state.errorTime = new Date()
      },
    )
    .addMatcher(isAnyOf(sendRsvp.rejected, updateRsvp.rejected), (state, action) => {
      const error: HttpError = action.payload as HttpError
      const errorKey = error?.response?.data?.details.applicationError?.code

      state.error = errorKey
        ? {...error?.response?.data?.details?.applicationError, error_key: errorKey}
        : {error_key: RegistrationErrorKey.UNKNOWN_REGISTRATION_ERROR}
      state.canRetry = canRetryError(error)
      state.errorTime = new Date()
    })
    .addMatcher(
      isAnyOf(
        resetRsvpError,
        placeOrder.fulfilled,
        updateOrder.fulfilled,
        getOrder.fulfilled,
        makeReservation.pending,
        updateRsvpOld.fulfilled,
        sendRsvp.fulfilled,
        updateRsvp.fulfilled,
      ),
      state => {
        state.error = {}
        state.errorTime = null
        state.canRetry = false
      },
    )
})

const canRetryError = (error: HttpError) => {
  return error?.response?.status > 500 || error?.response?.status === 429
}
